<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppBox from '@/components/app/box.vue';
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import AppConversation from '@/components/app/conversation.vue';
  import HumanFrontComponent from '@/components/HumanFrontComponent.vue';
  import HumanBackComponent from '@/components/HumanBackComponent.vue';
  export default {
    components: {
      AppBox,
      AppTitleHeader,
      HumanFrontComponent,
      HumanBackComponent,
      AppConversation,
    },
    props: {
      front: {
        type: Array,
        default: () => [],
      },
      back: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {};
    },
    watch: {
      // front:{
      //   handler:function(currentVal){
      //   },
      //   immediate:true
      // }
    },
  };
</script>
<template>
  <v-row no-gutters class="pa-4 relative">
    <v-col cols="12" class="mb-4">
      <app-title-header title="معاینه سر تا پا" />
    </v-col>
    <v-col cols="6">
      <app-box outlined max-height="900px">
        <app-box v-for="{ id, bodyPartId, color, typeOfInjury } in front" :key="id" class="mb-2">
          <div class="flex-gap-2">
            <div :style="`border-right-color:${color};`" class="part-color pr-2">
              {{ bodyPartId }}
            </div>
            -
            <app-conversation question="جلو" :answer="typeOfInjury" />
          </div>
        </app-box>
        <app-box v-for="{ id, bodyPartId, color, typeOfInjury } in back" :key="id" class="mb-2">
          <div class="flex-gap-2">
            <div :style="`border-right-color:${color};`" class="part-color pr-2">
              {{ bodyPartId }}
            </div>
            -
            <app-conversation question="عقب" :answer="typeOfInjury" />
          </div>
        </app-box>
      </app-box>
    </v-col>
    <v-col cols="6">
      <section class="flex-gap-4 justify-around mb-4">
        <div class="font-weight-bold human-body-title">جلو</div>
        <div class="human-svg-container">
          <human-front-component :data="front" />
        </div>
      </section>

      <section class="flex-gap-4 justify-between">
        <div class="human-svg-container">
          <human-back-component :data="back" class="human-back-svg-component" />
        </div>
        <div class="font-weight-bold human-body-title">عقب</div>
      </section>
    </v-col>
  </v-row>
</template>
<style lang="scss" scoped>
  .part-color {
    border-right-width: 8px;
    border-right-style: solid;
  }
  .human-body-title {
    font-size: 1.1rem;
  }
  .human-svg-container {
    position: relative;
    height: 450px;
    width: 250px;
    .human-back-svg-component {
      position: absolute;
      top: -11%;
      left: -50%;
      transform: translate(-50%, 100%);
    }
  }
</style>
